import MobileCanvas from "./MobileCanvas";

export default MobileCanvas;
